import axios from 'axios';
import { Academics, Alumni, Content, Path } from './types';
import { baseUrl } from './constants';

export async function getMajor(id: number) {
  const result = await axios.get(`${baseUrl}/api/majors/${id}`);
  return result;
}

export async function getMajors() {
  const result = await axios.get(`${baseUrl}/api/majors`);
  return result;
}

export async function getGroup(id: number) {
  const result = await axios.get(`${baseUrl}/api/majors/group/${id}`);
  return result;
}

export async function getPath(id: number) {
  const result = await axios.get(`${baseUrl}/api/paths/${id}`);
  return result;
}

export async function postPath(path: Path) {
  try {
    const apiUrl = `${baseUrl}/api/paths`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };

    const response = await axios.post(apiUrl, path, { headers });
    if (response.status === 200) {
    } else {
      console.error('Request failed with status:', response.status);
    }
    return response;
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

export async function updatePath(path: Path) {
  try {
    const apiUrl = `${baseUrl}/api/paths/${path.id}`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };

    const response = await axios.put(apiUrl, path, { headers });

    if (response.status === 200) {
    } else {
      console.error('Request failed with status:', response.status);
    }
    return response;
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

export async function deletePath(id: number) {
  try {
    const apiUrl = `${baseUrl}/api/paths/${id}`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };
    const response = await axios.delete(apiUrl, { headers });

    if (response.status === 200) {
    } else {
      console.error('Delete failed with status:', response.status);
    }
    return response;
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

export async function getAlum(id: number) {
  const result = await axios.get(`${baseUrl}/api/alumni/${id}`);
  return result;
}

export async function postAlum(alum: Alumni) {
  try {
    const apiUrl = `${baseUrl}/api/alumni`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };

    const response = await axios.post(apiUrl, alum, { headers });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Request failed with status:', response.status);
    }
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

export async function updateAlum(alum: Alumni) {
  if (alum.id === 0) {
    return await postAlum(alum);
  }
  try {
    const apiUrl = `${baseUrl}/api/alumni/${alum.id}`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };

    const response = await axios.put(apiUrl, alum, { headers });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Request failed with status:', response.status);
    }
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

export async function deleteAlum(id: number) {
  try {
    const apiUrl = `${baseUrl}/api/alumni/${id}`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };
    const response = await axios.delete(apiUrl, { headers });

    if (response.status === 200) {
    } else {
      console.error('Delete failed with status:', response.status);
    }
    return response;
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

export async function postDraft(content: Content) {
  try {
    const apiUrl = `${baseUrl}/api/content/draft`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };

    const response = await axios.post(apiUrl, content, { headers });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Request failed with status:', response.status);
    }
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

export async function postPublish(content: Content) {
  try {
    const apiUrl = `${baseUrl}/api/content/publish`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };

    const response = await axios.post(apiUrl, content, { headers });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Request failed with status:', response.status);
    }
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

export async function updateDraft(content: Content) {
  if (content.id === 0) {
    postDraft(content);
    return;
  }
  try {
    const apiUrl = `${baseUrl}/api/content/draft/${content.id}`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };

    const response = await axios.put(apiUrl, content, { headers });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Request failed with status:', response.status);
    }
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

export async function updatePublish(content: Content) {
  if (content.id === 0) {
    postPublish(content);
  }
  try {
    const apiUrl = `${baseUrl}/api/content/publish/${content.id}`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };

    const response = await axios.put(apiUrl, content, { headers });

    if (response.status === 200) {
    } else {
      console.error('Request failed with status:', response.status);
    }
    return response;
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

export async function updateAcademicsDraft(content: Academics) {
  try {
    const apiUrl = `${baseUrl}/api/academics/draft/${content.id}`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };

    const response = await axios.put(apiUrl, content, { headers });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Request failed with status:', response.status);
    }
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

export async function updateAcademicsPublish(
  academics: Academics,
  publishId: number
) {
  try {
    if (publishId === 0) {
      const response = await postAcademicsPublish(academics);
      return response;
    }
    academics.id = publishId;
    const apiUrl = `${baseUrl}/api/academics/publish/${publishId}`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };

    const response = await axios.put(apiUrl, academics, { headers });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Request failed with status:', response.status);
    }
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

export async function postAcademicsDraft(academics: Academics) {
  try {
    const apiUrl = `${baseUrl}/api/academics/draft`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };

    const response = await axios.post(apiUrl, academics, { headers });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Request failed with status:', response.status);
    }
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

export async function postAcademicsPublish(academics: Academics) {
  academics.id = 0;
  try {
    const apiUrl = `${baseUrl}/api/academics/publish`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };

    const response = await axios.post(apiUrl, academics, { headers });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Request failed with status:', response.status);
    }
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

export async function refreshMajors() {
  try {
    const apiUrl = `${baseUrl}/api/refreshMajors`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': '092857BC15104B02AD868AD60185E33D',
    };

    const response = await axios.get(apiUrl, { headers });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Request failed with status:', response.status);
    }
  } catch (error) {
    console.error('An error refreshing majors:', error);
  }
}
